import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { eventTracker } from '_helpers';
import { connect } from 'react-redux';
import { _ } from '_locales';
import { useHistory } from 'react-router-dom';
import { useTimer } from '../../../../hooks/useTimer';
import events from '../../events';
import VimeoPlayer from '../../components/VimeoPlayer';
import { Arrow, ArrowsContainer } from '../../../../styles/common-styles';
import { Button } from '../../components';
import { goToTop } from '../../../../helpers';

const RFDetails = ({
  rfLessonItemIndex, rf_lessons, nextRFHandler, previousRFHandler, templateColors
}) => {
  const history = useHistory();
  const { main_color } = templateColors;
  const { coachable_id, video_link, message } = rf_lessons[rfLessonItemIndex].activities[0];

  // calculates how much time is spent
  useTimer(({ duration }) => eventTracker(
    events.DZ_RF_PAGE_TIME_SPENT,
    {
      time_spent: duration,
      rf_id: rf_lessons[rfLessonItemIndex].campaign_id,
      activity_id: rf_lessons[rfLessonItemIndex].activities[0].coachable_id
    }
  ));

  const onVideoStart = (activity_id) => {
    eventTracker(
      events.DZ_RF_VIDEO_START,
      { activity_id }
    );
  };

  const onVideoEnded = (activity_id) => {
    eventTracker(
      events.DZ_RF_VIDEO_END,
      { activity_id }
    );
  };

  useEffect(() => {
    eventTracker(
      events.DZ_RF_LAND,
      { activity_id: coachable_id, rf_id: rf_lessons[rfLessonItemIndex].campaign_id }
    );
  }, [rfLessonItemIndex]);

  return (
    <Container key={rfLessonItemIndex}>
      <DetailsVideoWrapper>
        <VimeoPlayer
          onVideoStart={() => onVideoStart(coachable_id)}
          onVideoEnded={() => onVideoEnded(coachable_id)}
          videoId={video_link}
        />
      </DetailsVideoWrapper>
      <CardSummaryFull dangerouslySetInnerHTML={{ __html: message }} />
      {rfLessonItemIndex === rf_lessons.length - 1 && (
        <ButtonWrapper>
          <Button
            style={{}}
            mainColor={main_color || false}
            onClick={() => {
              goToTop();
              history.push('/quiz/rf/0');
            }}
            aria-label="Get Certified"
          >
            {_('education.get_certified')}
          </Button>
        </ButtonWrapper>
      )}
      <ArrowsContainer>
        <Arrow
          disabled={rfLessonItemIndex === 0}
          background="#269EE2"
          onClick={previousRFHandler}
          aria-label="Previous Recycle Fundamentals Lesson"
        >
          &#8678;
        </Arrow>
        <Arrow
          disabled={rfLessonItemIndex === rf_lessons.length - 1}
          background="#269EE2"
          onClick={nextRFHandler}
          aria-label="Next Recycle Fundamentals Lesson"
        >
          &#8680;
        </Arrow>
      </ArrowsContainer>
    </Container>
  );
};

export default connect((store) => ({
  templateColors: store.config.templateColour ? JSON.parse(store.config.templateColour) : {},
}), null)(RFDetails);

const OpacityAnimation = keyframes`
  from {opacity: 0;}
  to {opacity: 1;}
`;

const Container = styled.div`
  animation: ${OpacityAnimation} 0.3s;
`;

const DetailsVideoWrapper = styled.div`
  display: flex;
  justify-content: center;
  animation: ${OpacityAnimation} 0.5s;
  opacity: 0;
  animation-fill-mode: forwards;
  animation-delay: 0.7s;
`;

const CardSummaryFull = styled.div`
  animation: ${OpacityAnimation} 0.5s;
  color: #404040 !important;
  padding: 10px 20px;
  text-align: left !important;
  p, li {
    color: #404040;
    font-size: 16px !important;
    font-family: Roboto, sans-serif !important;
    text-align: left !important;
  }

  h1, h2, h3, h4, h5, h6, b, strong{
    font-weight: bold !important;
    margin: 20px 0 15px;
    text-align: left !important;
  }
 
  h1 { font-size: 20px !important;   }
  h2 { font-size: 18px !important;   }
  h3 { font-size: 16px !important;   }
  h4 { font-size: 14px !important;   }
  h5 { font-size: 13px !important;   }
  h6 { font-size: 13px !important;   }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;

  & button {
    margin: 20px 0;
  }
`;
